import React from "react";

const HydraFacialCustomer = () => {
  return (
    <div className="organicFacialCustomerContainer">
      <h5>Testimonials from Satisfied Clients</h5>
      <p>
        Here’s what some of our satisfied clients have to say about our Hydra
        Lifting Ocean Miracle Facial Services in Bangalore:
      </p>
      <div className="organicFacialCustomerContent">
        <p>
          <span className="quote">“</span>The Hydra Lifting Ocean Miracle Facial
          at SCENT is incredible! My skin feels so hydrated and lifted after
          each session. I highly recommend it <span className="quote">”</span> -{" "}
          <span> Priya S </span>
        </p>
        <p>
          <span className="quote">“</span> I love the personalized approach at
          SCENT. The estheticians are so knowledgeable, and the Hydra Lifting
          Ocean Miracle Facial has done wonders for my skin
          <span className="quote">”</span> - <span>Anjali R. </span>
        </p>
        <p>
          <span className="quote">“</span>SCENT provides a luxurious and
          relaxing experience. The Hydra Lifting Ocean Miracle Facial has become
          my go-to treatment for maintaining youthful and radiant skin.{" "}
          <span className="quote">”</span> - <span>Ritu M. </span>
        </p>
      </div>
    </div>
  );
};

export default HydraFacialCustomer;
